module.exports = __webpack_public_path__ + "static/media/Ratchet and Clank.db076205.mp4";